const SEPARATOR = ',';
const ESCAPE = '\\';

/**
 * Las listas viajan por la URL separadas por coma para que sea legible y compartible
 * (diseño §11). Un valor que contenga una coma la lleva escapada, de modo que el
 * round-trip nunca parte una etiqueta como "rojo, azul" en dos.
 */
export const encodeCsv = (values: readonly string[]): string =>
  values.map(escapeItem).join(SEPARATOR);

export const decodeCsv = (raw: string): string[] => {
  if (raw === '') return [];
  const items: string[] = [];
  let current = '';
  let escaped = false;
  for (const char of raw) {
    if (escaped) {
      current += char;
      escaped = false;
    } else if (char === ESCAPE) {
      escaped = true;
    } else if (char === SEPARATOR) {
      items.push(current);
      current = '';
    } else {
      current += char;
    }
  }
  // Una barra final suelta no es un escape válido; se conserva como carácter.
  if (escaped) current += ESCAPE;
  items.push(current);
  return items;
};

const escapeItem = (value: string): string =>
  value.replaceAll(ESCAPE, ESCAPE + ESCAPE).replaceAll(SEPARATOR, ESCAPE + SEPARATOR);
